import { render, staticRenderFns } from "./setPostalCodeModal.vue?vue&type=template&id=2dcbf594"
import script from "./setPostalCodeModal.vue?vue&type=script&lang=js"
export * from "./setPostalCodeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports